var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "moinitoring" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.active != null
        ? _c(
            "nav",
            { staticClass: "navbar fixted-top navbar-light bg-light" },
            [
              _c("div", { staticClass: "navbar-brand" }, [
                _vm._v("Monitoring")
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "nav nav-pages mr-auto" }, [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: true },
                      attrs: { type: "button" }
                    },
                    [_vm._v("Recommended")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nav-item btn-group dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn-block btn dropdown-toggle btn-secondary text-right",
                    staticStyle: { "margin-right": "10px" },
                    attrs: {
                      type: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.active.account_name) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "dropdown-menu dropdown-menu-right scrollable-menu"
                  },
                  [
                    _c("h6", { staticClass: "dropdown-header" }, [
                      _vm._v("Accounts")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.monitoring, function(report) {
                      return _c("div", { key: report.account }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function($event) {
                                _vm.active = report
                              }
                            }
                          },
                          [_vm._v(_vm._s(report.account_name))]
                        )
                      ])
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary text-right",
                  attrs: { type: "button" },
                  on: { click: _vm.downloadCSV }
                },
                [_vm._v("Download Report")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.active != null
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("transition", { attrs: { name: "fade", appear: "" } }, [
                    _c("div", { staticClass: "card col" }, [
                      _c("div", { staticClass: "card-heading" }, [
                        _c("h4", [_vm._v("Account")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("dl", [
                          _c("dt", [_vm._v("Contract")]),
                          _c("dd", [_vm._v(_vm._s(_vm.active.contract))]),
                          _vm._v(" "),
                          _c("dt", [_vm._v("Account Name")]),
                          _c("dd", [_vm._v(_vm._s(_vm.active.account_name))]),
                          _vm._v(" "),
                          _c("dt", [_vm._v("Account Id")]),
                          _c("dd", [_vm._v(_vm._s(_vm.active.account))]),
                          _vm._v(" "),
                          _c("dt", [_vm._v("Guardian Alarms")]),
                          _c("dd", [
                            _vm._v(_vm._s(_vm.countAlarms("MetricAlarms")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "progress",
                            staticStyle: {
                              height: "25px",
                              "margin-top": "10px"
                            }
                          },
                          [
                            _c("span", { staticClass: "progress-text" }, [
                              _vm._v(
                                _vm._s(_vm.alarmCoverage()) + "% Alarm Coverage"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "progress-bar bg-success",
                              style: { width: _vm.alarmCoverage() + "%" },
                              attrs: {
                                role: "progressbar",
                                "aria-valuenow": "25",
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "progress-bar bg-danger",
                              style: { width: 100 - _vm.alarmCoverage() + "%" },
                              attrs: {
                                role: "progressbar",
                                "aria-valuenow": "25",
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("transition", { attrs: { name: "fade", appear: "" } }, [
                    _vm.activeResource != null
                      ? _c("div", { staticClass: "card col" }, [
                          _c("div", { staticClass: "card-heading" }, [
                            _c("h4", [_vm._v("Metric Resource")])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-body" }, [
                            _c("dl", { staticClass: "metric-details" }, [
                              _c("dt", [_vm._v("Namespace")]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(_vm._s(_vm.activeResource.Namespace))
                              ]),
                              _vm._v(" "),
                              _c("dt", [_vm._v("Metric Name")]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(_vm._s(_vm.activeResource.MetricName))
                              ]),
                              _vm._v(" "),
                              _c("dt", [_vm._v("Monitoring Rating")]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(
                                  _vm._s(_vm.activeResource.MonitoringRating)
                                )
                              ]),
                              _vm._v(" "),
                              _c("dt", [_vm._v("Resource Name")]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getResourceName(_vm.activeResource)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("dt", [_vm._v("Resource Type")]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getResourceType(_vm.activeResource)
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "h5",
                              { staticStyle: { "margin-top": "10px" } },
                              [_vm._v("Dimensions")]
                            ),
                            _vm._v(" "),
                            _c(
                              "dl",
                              { staticClass: "dimensions" },
                              _vm._l(_vm.activeResource.Dimensions, function(
                                dimension
                              ) {
                                return _c("div", { key: dimension.Name }, [
                                  _c("dt", [_vm._v(_vm._s(dimension.Name))]),
                                  _vm._v(" "),
                                  _c("dd", [_vm._v(_vm._s(dimension.Value))])
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              { staticStyle: { "margin-top": "10px" } },
                              [_vm._v("Description")]
                            ),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.activeResource.Documentation.Description
                                )
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-9" },
              [
                _c(
                  "transition",
                  { attrs: { name: "fade", appear: "" } },
                  [
                    _c(
                      "vue-good-table",
                      {
                        attrs: {
                          columns: _vm.metricTableColumns,
                          rows: _vm.active.metric_alarms,
                          "search-options": {
                            enabled: true,
                            skipDiacritics: true,
                            placeholder: "filter"
                          },
                          "pagination-options": {
                            enabled: true,
                            perPage: 15
                          },
                          "row-style-class": _vm.rowStyleClassFn,
                          styleClass: "vgt-table condensed"
                        },
                        on: { "on-row-click": _vm.onRowClick }
                      },
                      [
                        _c(
                          "div",
                          {
                            attrs: { slot: "table-actions" },
                            slot: "table-actions"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-margin btn-sm",
                                attrs: { type: "button" },
                                on: { click: _vm.showMissingAlarmsRows }
                              },
                              [_vm._v("Show Missing")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-success btn-margin btn-sm",
                                attrs: { type: "button" },
                                on: { click: _vm.showAllAlarmsRows }
                              },
                              [_vm._v("Show All")]
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.active != null && _vm.activeResource != null
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _c("transition", { attrs: { name: "fade", appear: "" } }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("h4", [_vm._v("Recommended Alarms")]),
                    _vm._v(" "),
                    _c("vue-good-table", {
                      attrs: {
                        columns: _vm.recommendedAlarmsTableColumns,
                        rows: _vm.activeResource.RecommendedAlarms,
                        styleClass: "vgt-table condensed"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.active != null && _vm.activeResource != null
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _c("transition", { attrs: { name: "fade", appear: "" } }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("h4", [_vm._v("Metric Alarms")]),
                    _vm._v(" "),
                    _c("vue-good-table", {
                      attrs: {
                        columns: _vm.metricAlarmsTableColumns,
                        rows: _vm.activeResource.MetricAlarms,
                        styleClass: "vgt-table condensed"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2beb1bfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2beb1bfc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Monitoring.vue
// module id = null
// module chunks = 